import { ReactElement } from 'react'
import { SubHeader } from '../../../../components'
import { getSubjectLogo } from '../../../../helpers'
import ScheduledTests from '../ScheduledTests'
import { TestTypeWrapperProps } from './typings'

const ScheduledTestsWrapper = ({
  title,
  scheduledTests,
  handleBack
}: TestTypeWrapperProps): ReactElement => {
  return (
    <>
      <SubHeader
        title={title}
        logo={getSubjectLogo({
          subject: title
        })}
        handleBack={handleBack}
      />
      <ScheduledTests scheduledTests={scheduledTests} isPractice />
    </>
  )
}

export default ScheduledTestsWrapper
